import { useQuery } from '~/hooks/useQuery';

import { ActivityTypeEnum } from '../../../../enums';

export const useLoadPartnerLogHoursReportByType = (
  connectionId: string,
  activityType: ActivityTypeEnum,
) => {
  const { data, isLoading, isRefetching } = useQuery<{ count: number }>(
    `measurement-insights/partner/${connectionId}/total-time-logged-by-activity-type`,
    {
      requestOptions: {
        params: {
          activityType: ActivityTypeEnum[activityType],
        },
      },
      key: `measurement-insights/partner/${connectionId}/total-time-logged-by-activity-type`,
    },
  );

  return { data, isLoading, isRefetching };
};
